import { z } from 'zod';
import { Currencies } from '../settings/tasa-schema';

export const BillingRecordSchema = z.object({
  amount: z.number(),
  currency: Currencies.default('USD'),
  date: z.any(), // Timestamp of when the payment was made/received
  plan: z.enum(['SOLO', 'SALON', 'GROWTH']).optional(),
  method: z.string(), // e.g., 'Zelle', 'Binance', 'Efectivo', 'Pago Móvil', 'Transferencia'
  reference: z.string().optional(),
  notes: z.string().optional(),
  
  // Status of this payment record
  status: z.enum(['pending', 'approved', 'rejected']).default('approved'),
  
  // Proof of payment (for clients uploading capture)
  captureUrl: z.string().url().optional(),

  // Audit
  recordedBy: z.string(), // Admin UID or 'system' or 'owner'
  createdAt: z.any(), // Timestamp of record creation
  updatedAt: z.any().optional(),
  updatedBy: z.string().optional(), // Admin who approved/rejected
});

export type BillingRecord = z.infer<typeof BillingRecordSchema>;
export type BillingRecordWithId = BillingRecord & { id: string };
